///<reference path="../typings/browser.d.ts" />
"use strict";
var popgun = require('popgun').default;
exports.name = 'AngularPopgun';
exports.angularModule = angular.module(exports.name, [])
    .factory('AngularPopgunSrvc', function ($compile) {
    var AngularPopgunSrvc = {
        appSetup: function () {
            popgun.init();
        },
        init: function ($scope, el, preserveScope) {
            if (!el.hasAttribute('popgun-listening')) {
                var $compileScope_1;
                var setupPopHandler_1 = function (e) {
                    $compileScope_1 = preserveScope ? $scope : $scope.$new();
                    var pop = popgun.getPopFromGroupId(e.target.getAttribute('popgun-group'));
                    $compile(pop.popOver.element)($compileScope_1);
                    $compileScope_1.$apply();
                };
                var cleanupPopHandler_1 = function (e) {
                    var pop = e.detail.pop;
                    if (pop && !preserveScope) {
                        var $popEl = angular.element(pop.popOver.element);
                        var $elementScope = $popEl.scope();
                        if ($compileScope_1 === $elementScope) {
                            $elementScope.$destroy();
                            $popEl.remove();
                        }
                        else {
                            console.error('The scope associated to the content has somehow changed, can not destroy the scope.');
                        }
                    }
                };
                el.addEventListener('PopgunContentSetup', setupPopHandler_1, false);
                el.addEventListener('PopgunContentSwap', cleanupPopHandler_1);
                el.addEventListener('PopgunContentRemove', cleanupPopHandler_1);
                angular.element(el).on('_AngularPopgunDestroy', function () {
                    el.removeEventListener('PopgunContentSetup', setupPopHandler_1);
                    el.removeEventListener('PopgunContentSwap', cleanupPopHandler_1);
                    el.removeEventListener('PopgunContentRemove', cleanupPopHandler_1);
                    angular.element(el).off('_AngularPopgunDestroy');
                });
                el.setAttribute('popgun-listening', '');
            }
            else {
                throw new Error('Popgun has already set a listener on this element. Do not instantiate again!');
            }
        },
        destroy: function (el) {
            angular.element(el).trigger('_AngularPopgunDestroy');
        },
        // Store a group w/ options to reuse
        // schema is a base set of options, options attr will precedence over schema
        registerGroup: function (groupId, opts) {
            popgun.registerGroup(groupId, opts);
        },
        // Store a schema of options
        registerSchema: function (schemaId, opts) {
            popgun.registerSchema(schemaId, opts);
        },
        // Returns a popover model based on a group
        getPopFromGroupId: function (groupId) {
            return popgun.getPopFromGroupId(groupId);
        },
        // Returns the state of a given popover
        // (hidden, content_setup, pre_position, pre_show, showing, pre_hide)
        getPopState: function (groupId) {
            return popgun.getPopState(popgun.getPopFromGroupId(groupId));
        },
        // Returns a boolean about whether a popover for a specific target is alrady open
        isPopAlreadyOpenForTarget: function (target) {
            return popgun.isPopAlreadyOpenForTarget(target);
        },
        // Returns a boolean about whether a popover is already open for a group
        isPopAlreadyOpenForGroup: function (groupId) {
            return popgun.isPopAlreadyOpenForGroup(groupId);
        },
        // Show the popover for a particular target
        showPop: function (target, isPinned, trigger) {
            return popgun.showPop(target, isPinned, trigger);
        },
        // Hide the popover for a particular target
        hidePop: function (target, hideFullChain) {
            return popgun.hidePop(target, hideFullChain);
        },
        // reposition the popover based on groupId for sync purposes
        reposition: function (groupId) {
            popgun.reposition(groupId);
        }
    };
    return AngularPopgunSrvc;
});
//# sourceMappingURL=index.js.map